var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("icon", { attrs: { "icon-name": _vm.workflowStateIcon } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }